import Bullet from './component.styles'
export default Bullet
